<template>
  <section class="section upload">
    <div class="container">
      <div class="product-upload container-fluid">
        <Loading :active.sync="loading"></Loading>
        <div class="columns">
          <div class="column">
            <b-field :label="$t('Auction')" custom-class="is-small required">
              <b-select
                :placeholder="$t('Select auction')"
                @input="selectAuction"
                :v-model="product.auction_id"
                :value="product.auction_id"
                size="is-small"
                expanded
              >
                <option
                  v-for="(auction, index) in auctionsList"
                  :value="auction.id"
                  :key="index"
                >{{ auction.id }} {{ auction.name }} - {{ auction.start | moment() }}</option>
              </b-select>
            </b-field>
            <Validator :_errors="errors" _param="err_select_auction" />
          </div>
          <div class="column">
            <h1 class="title">{{ $t("Product upload (auction)") }}</h1>
          </div>
        </div>
        <div class="columns">
          <div class="column is-half-desktop is-one-second-widescreen">
            <form method="post" id="form-product">
              <b-field :label="$t('Product type')" custom-class="is-small required">
                <treeselect
                  v-model="product.Category.main"
                  :multiple="true"
                  value="id"
                  :normalizer="normalizer"
                  :show-count="true"
                  :flat="true"
                  :autoDeselectDescendants="true"
                  :autoSelectAncestors="true"
                  :load-options="loadOptions"
                  :placeholder="$t('Select…')"
                  :options="categoriesList"
                  class="is-small"
                />
              </b-field>
              <Validator :_errors="errors" _param="err_select_category" />
              <b-tabs
                size="is-small"
                position="is-centered"
                type="is-boxed"
                v-model="selectedLangTab"
                @input="selectLangTab"
                expanded
              >
                <b-tab-item :label="$t('Hungarian')">
                  <b-field :label="$t('Name')" custom-class="is-small required">
                    <b-input
                      size="is-small"
                      name="name"
                      v-model="product.name"
                      type="text"
                    ></b-input>
                  </b-field>
                  <Validator :_errors="errors" _param="err_product_name_too_long, err_product_name_empty"
                  />
                  <b-field :label="$t('Description')" custom-class="is-small">
                    <b-input
                      size="is-small"
                      type="textarea"
                      name="description"
                      rows="3"
                      v-model="product.description"
                    ></b-input>
                  </b-field>
                </b-tab-item>
                <b-tab-item :label="$t('English')">
                  <b-field :label="$t('Name')" custom-class="is-small">
                    <b-input
                      size="is-small"
                      name="name"
                      v-model="product.long_description.en.name"
                      type="text"
                    ></b-input>
                  </b-field>
                  <b-field :label="$t('Description')" custom-class="is-small">
                    <b-input
                      size="is-small"
                      type="textarea"
                      name="description"
                      rows="3"
                      v-model="product.long_description.en.description"
                    ></b-input>
                  </b-field>
                </b-tab-item>
              </b-tabs>

              <p class="has-text-centered">
                <b-button
                  v-on:click="translate"
                  type="is-primary"
                  size="is-small"
                  outlined
                >{{ $t('Translate') }}</b-button>
              </p>

              <div class="columns">
                <div class="column">
                  <label class="label is-small">{{ $tc("city") }}</label>
                  <treeselect
                    v-model="product.Category.city"
                    v-if="citiloaded"
                    :multiple="true"
                    value="id"
                    @select="selectParent"
                    :normalizer="normalizer"
                    :show-count="true"
                    :placeholder="$t('Select…')"
                    :load-options="loadCities"
                    :default-options="citiesListDefault"
                    :async="true"
                    :no-results-text="$t('No results…')"
                    :loading-text="$t('In progress…')"
                    class="is-small"
                  />
                </div>

                <div class="column">
                  <label class="label is-small">{{ $tc("region") }}</label>
                  <treeselect
                    v-model="product.Category.county"
                    :multiple="true"
                    value="id"
                    @select="selectParent"
                    :normalizer="normalizer"
                    :show-count="true"
                    :load-options="loadOptions"
                    :placeholder="$t('Select…')"
                    :options="countiesList"
                    class="is-small"
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <label class="label is-small">{{ $tc("country") }}</label>
                  <treeselect
                    v-model="product.Category.country"
                    :multiple="true"
                    value="id"
                    @select="selectParent"
                    :normalizer="normalizer"
                    :show-count="true"
                    :load-options="loadOptions"
                    :placeholder="$t('Select…')"
                    :options="countriesList"
                    class="is-small"
                  />
                </div>

                <div class="column">
                  <label class="label is-small">{{ $tc("continent") }}</label>
                  <treeselect
                    v-model="product.Category.continent"
                    :multiple="true"
                    value="id"
                    :normalizer="normalizer"
                    :show-count="true"
                    :load-options="loadOptions"
                    :placeholder="$t('Select…')"
                    :options="continentsList"
                    class="is-small"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column is-6">
                  <label for="tags" class="label is-small">{{ $tc('tag', 2) }}</label>
                  <b-field>
                    <b-taginput
                      v-model="product.Category.tags"
                      :data="filteredTags"
                      autocomplete
                      name="tags"
                      size="is-small"
                      field="name"
                      @typing="getFilteredTags"
                      icon="tags"
                    >
                      <template slot-scope="props">{{props.option.name}}</template>
                    </b-taginput>
                  </b-field>
                </div>
                <div class="column">
                  <b-field :label="$t('Submitter id')" custom-class="is-small">
                    <b-numberinput
                      size="is-small"
                      name="seller_id"
                      v-model="product.seller_id"
                      type="text"
                      :controls="false"
                      min="0"
                    ></b-numberinput>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <label class="label is-small">{{ $t('Provide date range') }}</label>
                </div>
                <div class="column">
                  <label for="year_from" class="label is-small">{{ $t("Year from") }}</label>
                  <b-field custom-class="is-small">
                    <b-numberinput
                      name="year_from"
                      size="is-small"
                      v-model="product.year_from"
                      type="is-light"
                      @blur="changeYearFrom"
                    ></b-numberinput>
                  </b-field>
                </div>
                <div class="column">
                  <label for="year_to" class="label is-small">{{ $t("Year to") }}</label>
                  <b-field custom-class="is-small">
                    <b-numberinput
                      name="year_to"
                      size="is-small"
                      v-model="product.year_to"
                      type="is-light"
                      @blur="changeYearTo"
                    ></b-numberinput>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column check-featured">
                  <b-field custom-class="is-small">
                    <b-checkbox
                      true-value="1"
                      false-value="0"
                      name="featured"
                      size="is-small"
                      v-model="product.Bid.featured"
                      type="is-primary"
                    >
                      <span class="has-text-weight-bold">{{ $t("Set as featured product") }}</span>
                    </b-checkbox>
                  </b-field>
                </div>

                <div class="column">
                  <label for="sku" class="label is-small required">{{ $t("SKU (stock-keeping unit)") }}</label>
                  <b-field custom-class="is-small">
                    <b-numberinput
                      name="sku"
                      size="is-small"
                      v-model="product.sku"
                      type="is-light"
                    ></b-numberinput>
                  </b-field>
                  <Validator :_errors="errors" _param="err_sku_empty, err_sku_only_number, err_sku_not_in_range" />
                </div>

                <div class="column">
                  <label for="price" class="label is-small required">{{ $t("Opening price") }}</label>
                  <b-field custom-class="is-small">
                    <b-numberinput
                      name="price"
                      size="is-small"
                      v-model="product.Bid.price"
                      step="1000"
                      :disabled="product.Bid.winner_id!==null"
                      type="is-light"
                    ></b-numberinput>
                  </b-field>
                  <Validator :_errors="errors" _param="err_price_empty, err_only_number" />
                </div>
              </div>
            </form>

            <!-- <div id="dialog"></div> -->
            <div class="columns is-mobile">
              <div class="column">
                <b-button size="is-small" v-on:click="goToAdminBid">
                  {{ $t("Back") }}
                </b-button>
              </div>
              <div class="column has-text-right">
                <b-button
                  size="is-small"
                  type="is-primary"
                  v-on:click="uploadProduct()"
                >{{ $t("Save") }}</b-button>
              </div>
            </div>
          </div>

          <div class="column is-half-desktop is-one-second-widescreen">
            <form method="post" id="upload-form" enctype="multipart/form-data">
              <template>
                <section>
                  <b-field :label="$t('Upload image')" custom-class="is-small required"></b-field>
                  <b-field custom-class="is-small">
                    <b-upload v-model="product.files" @input="changeUpload" multiple drag-drop>
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"></b-icon>
                        </p>
                        <p>{{ $t("Click here or drag and drop an image here") }}</p>
                      </div>
                    </b-upload>
                  </b-field>
                  <Validator :_errors="errors" _param="err_no_image" />
                  <div v-if="preview.length">
                    <div class="columns">
                        <div class="column is-2">
                        <label class="label is-small">{{ $t('Featured image') }}</label>
                        </div>
                        <div class="column is-5">
                        <label class="label is-small">{{ $t('Image title') }}</label>
                        </div>
                        <div class="column is-3">
                        <label class="label is-small">{{ $t('Preview') }}</label>
                        </div>
                        <div class="column"></div>
                    </div>
                    <div v-for="(file, key) in preview" v-bind:key="key" class="columns preview">
                        <div class="column is-2">
                        <b-radio
                            size="is-small"
                            :native-value="key"
                            v-model="product.main_image"
                            :id="'main_image_'+key"
                            name="main_image"
                        ></b-radio>
                        </div>
                        <div
                        class="column is-5 truncate is-size-7"
                        :title="product.files[key].name"
                        >{{ product.files[key].name }}</div>
                        <div class="column is-3">
                        <img v-if="file" :src="file" />
                        </div>
                        <div class="column has-text-right">
                        <b-button
                            type="is-danger"
                            size="is-small"
                            outlined
                            @click="removePicture(key)"
                        >{{ $t("Remove") }}</b-button>
                        </div>
                    </div>
                  </div>
                  <div v-if="product.Images.length">
                    <h2>{{ $t('Images stored in database') }}</h2>
                    <div class="columns">
                      <div class="column is-2">
                        <label class="label is-small">{{ $t('ID') }}</label>
                      </div>
                      <div class="column is-5">
                        <label class="label is-small">{{ $t('Featured image') }}</label>
                      </div>
                      <div class="column is-3">
                        <label class="label is-small">{{ $t('Preview') }}</label>
                      </div>
                      <div class="column"></div>
                    </div>
                    <div
                      v-for="(file, key) in product.Images"
                      v-bind:key="key"
                      class="columns preview"
                    >
                      <div class="column is-2 is-size-7">{{ file.id }}</div>
                      <div class="column is-5">
                        <b-radio
                          size="is-small"
                          :native-value="file.id"
                          @click.native="changeMainPicture(file.id)"
                          v-model="product.main_image"
                          name="main_image"
                        ></b-radio>
                      </div>
                      <div class="column is-3">
                        <img v-if="file" :src="'/' + file.thumb96" />
                      </div>
                      <div class="column has-text-right">
                        <b-button
                          type="is-danger"
                          size="is-small"
                          outlined
                          @click="removePictureDB(file.id)"
                        >{{ $t("Remove") }}</b-button>
                      </div>
                    </div>
                  </div>
                </section>
              </template>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Validator from "@/components/backend/products/Validator.vue";

export default {
	name: "ProductUpload",
	components: { Loading, Treeselect, Validator },
	metaInfo: {
		title: "Termék feltöltés",
		titleTemplate: "%s - htaukcio.com",
		htmlAttrs: {
			lang: "hu",
			amp: false
		},
		meta: [
			{ name: 'robots', content: 'noindex' },
		]
	},
	data() {
		var d = new Date();
		return {
			// minYear: 1000,
			maxYear: d.getFullYear()+80,
			citiloaded: false,
			selectedLangTab: 0,
			isPreviewActive: false,
			errors: [],
			auctionsList: [],
			categoriesList: [],
			countriesList: [],
			continentsList: [],
			countiesList: [],
			citiesList: [],
			citiesListDefault: [],
			filteredTags: this.tags,
			tagList: [],
			selectedTags: [],
			user: null,
			preview: [],
			loading: true,
			images: null,
			price: null,
			product: {
				seller_id: 3,
				auction_id: null,
				name: null,
				description: null,
				year_from: 1600,
				year_to: d.getFullYear(),
				product_type: 1,
				status: 0,
				Bid: {
					price: null,
					start: null,
					winner_id: null,
				},
				Category: {
					main: [],
					continent: [],
					country: [],
					county: [],
					city: [],
					tags: []
				},
				main_image: null,
				Images: [],
				files: null,
				sku: null,
				person_name: null,
				long_description: {
					en: {
						name: null,
						description: null
					}
				}
			}
		};
	},
	methods: {
		changeYearFrom(){
			if(this.product.year_from === null){
				// this.product.year_from = this.product.year_to;
			}else if(this.product.year_from > this.product.year_to){
				this.product.year_to = this.product.year_from;
			}
			if(this.product.year_from < this.minYear){
				// this.product.year_from = this.minYear;
				this.changeYearTo();
			}
			if(this.product.year_from > this.maxYear){
				this.product.year_from = this.maxYear;
				this.changeYearTo();
			}
			console.log('from')
		},
		changeYearTo(){
			if(this.product.year_to === null){
				// this.product.year_to = this.product.year_from;
			}else if(this.product.year_to < this.product.year_from){
				this.product.year_from = this.product.year_to;
			}
			if(this.product.year_to < this.minYear){
				// this.product.year_to = this.minYear;
				this.changeYearFrom();
			}
			if(this.product.year_to > this.maxYear){
				this.product.year_to = this.maxYear;
				this.changeYearFrom();
			}
		},
		goToAdminBid(){
			document.location.href='/admin/product';
		},
		selectParent(node){
			var _this = this;

			this.$http
				.get("/categories/child/" + node.id)
				.then(response => {
					response.data.parent_categories.forEach(function(val){
						if(val.type == 2 && _this.product.Category.continent.indexOf(val.parent_id) ==  -1){
							if(_this.product.Category.continent.indexOf(val.id) == -1){
								_this.product.Category.continent.push(val.id);
							}
						}
						if(val.type == 3 && _this.product.Category.country.indexOf(val.parent_id) ==  -1){
							if(_this.product.Category.country.indexOf(val.id) == -1){
								_this.product.Category.country.push(val.id);
							}
						}
						if(val.type == 4 && _this.product.Category.county.indexOf(val.parent_id) ==  -1){
							if(_this.product.Category.county.indexOf(val.id) == -1){
								_this.product.Category.county.push(val.id);
							}
						}
					})
				})
				.catch(error => {
					console.log(error);

				})
		},
		selectLangTab(e) {
			console.log(e);
		},
		transformPreview(cb) {
			var ret = [];
			for (var z in this.preview) {
				console.log(this.preview[z]);
				ret.push({ path: this.preview[z] });
			}
			console.log("computed", ret);
			this.images = ret;
			cb(ret);
		},
		teszt: function() {
			var _this = this;
			console.log(_this.product);
		},
		openProduct: function() {
			var _this = this;
			this.transformPreview(function() {
				_this.isPreviewActive = true;
			});
		},
		loadCities: function({ action, searchQuery, callback }) {
			if (searchQuery.length > 2) {
				this.$http
					.get("/categories/cities?name=" + searchQuery)
					.then(response => {
						this.citiesList = response.data.categories;
						callback(null, response.data.categories);
					});
			} else {
				this.$http
					.get("/categories/cities/" + this.$route.params.product_id)
					.then(response => {
						this.citiesListDefault = response.data.categories;
						callback(null, response.data.categories);
					});
			}
		},
		selectAuction: function(e) {
			var index = 0;
			this.auctionsList.map(function(d, i) {
				if (d.id == e) {
					index = i;
				}
			});
			if (this.auctionsList[index]) {
				this.product.auction_id = this.auctionsList[index].id;
				this.product.Bid.step = this.auctionsList[index].bid_step;
			}
		},
		removePictureDB: function(id) {
			var _this = this;
			_this.loading = true;
			const formData = new FormData();
			formData.append("images", JSON.stringify({ id: id }));
			_this.$http
				.delete("/images/" + id, formData)
				.then( () => {
					_this.product.Images = [];
					_this.getProduct(_this.$route.params.product_id, function() {
						_this.loading = false;
					});
				})
				.catch(error => {
					_this.loading = false;
					console.log(error);
				});
		},
		removePicture: function(seq) {
			this.product.files.splice(seq, 1);
			this.preview.splice(seq, 1);
		},
		changeMainPicture: function(id) {
			var _this = this;
			// console.log(id);

			const formData = new FormData();
			formData.append("images", JSON.stringify({ id: id }));
			_this.$http
				.post("/images/order/" + id)
				// .then(response => {
				// 	console.log(response);
				// })
				.catch(error => {
					console.log(error);
				});
		},
		getProduct(id, cb) {
			var _this = this;
			_this.preview = [];
			_this.product.files = [];
			_this.$http.get("/product/" + id).then(response => {
				_this.product.Images = [];
				if(response.data.product.long_description){
					_this.product.long_description =
						response.data.product.long_description != ""
							? JSON.parse(response.data.product.long_description)
							: { en: { name: null, description: null } };
				}
				if(response.data.product.Bid){
					_this.product.auction_id = response.data.product.Bid.auction_id;
				}
				_this.product.status = response.data.product.status;
				_this.product.year_from = response.data.product.year_from;
				_this.product.year_to = response.data.product.year_to;
				_this.product.seller_id = response.data.product.seller_id;
				_this.product.Category.main = [];
				//response.data.product.Categories.map(function(e){if(e.type == 1){_this.product.Category.main.push(e.id) }});
				_this.product.Category.city = [];
				_this.product.Category.county = [];
				_this.product.Category.continent = [];
				_this.product.Category.country = [];
				_this.product.Category.tags = [];
				response.data.product.Categories.map(function(e) {
					if (e.type == 1) {
						_this.product.Category.main.push(e.id);
					}
					if (e.type == 2) {
						_this.product.Category.continent.push(e.id);
					}
					if (e.type == 3) {
						_this.product.Category.country.push(e.id);
					}
					if (e.type == 4) {
						_this.product.Category.county.push(e.id);
					}
					if (e.type == 5) {
						_this.product.Category.city.push(e.id);
					}
					if (e.type == 6) {
						_this.product.Category.tags.push(e);
					}
				});
				response.data.product.Images.map(function(e) {
					if (e.weight == -1) {
						_this.product.main_image = e.id;
					}
				});
				_this.product = _this.lodash.mergeWith(
					response.data.product,
					_this.product,
					_this.customizer
				);
				if (typeof cb === 'function') {
					cb();
				} else {
					_this.loading = false;
				}
			});
		},
		customizer(objValue, srcValue) {
			if (objValue !== null && srcValue === null) {
				return objValue;
			}
		},
		getPictures(pid) {
			var _this = this;
			_this.$http.get("/images/" + pid).then(response => {
				_this.images = response.data.images;
				_this.loading = false;
			});
		},
		getCategories() {
			var _this = this;
			_this.$http.get("/categories/tree/1").then(response => {
				_this.categoriesList = response.data.categories;
				_this.loading = false;
			});
		},
		getContinents() {
			var _this = this;
			_this.$http.get("/categories/continents").then(response => {
				_this.continentsList = response.data.categories;
				_this.loading = false;
			});
		},
		getCountries() {
			var _this = this;
			_this.$http.get("/categories/countries").then(response => {
				_this.countriesList = response.data.categories;
				_this.loading = false;
			});
		},
		getCounties() {
			var _this = this;
			_this.$http.get("/categories/counties").then(response => {
				_this.countiesList = response.data.categories;
				_this.loading = false;
			});
		},
		getCities(pid) {
			var _this = this;
			_this.$http.get("/categories/cities/" + pid).then(response => {
				response.data.categories.map(function(e) {
					_this.citiesListDefault.push({
						id: e.id,
						name: e.name,
						children: null
					});
				});
				_this.citiloaded = true;
				//_this.citiesListDefault = response.data.categories;
				_this.loading = false;
			});
		},
		getTags() {
			var _this = this;
			_this.$http.get("/categories/tags").then(response => {
				_this.tagList = response.data.categories;
				_this.loading = false;
			});
		},
		getFilteredTags(text) {
			console.log(this.tagList);
			this.filteredTags = this.tagList.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0
				);
			});
		},
		getAuctions() {
			var _this = this;
			_this.$http.get("/auctions/active").then(response => {
				_this.auctionsList = response.data.auctions;
				_this.loading = false;
			});
		},
		getSKU() {
			var _this = this;
			_this.$http.get("/products/last_sku").then(response => {
				console.log(response);
				_this.product.sku = response.data.sku;
				_this.loading = false;
			});
		},
		getUser() {
			var _this = this;
			setTimeout(function() {
				_this.$http
					.get("/users")
					.then(response => {
						_this.user = response.data.user;
						_this.loading = false;
						if (!response.data.user.UserPreference || response.data.user.UserPreference.role !== 100) {
							_this.$router.push({ name: "Login" });
						}
					})
					.catch(() => {
						_this.$router.push({ name: "Login" });
					});
			},1);
		},
		changeUpload(file) {
			//const file = e.target.files;
			for (var z in file) {
				if (typeof file[z] == "object") {
					this.preview[z] = URL.createObjectURL(file[z]);
				}
			}
			setTimeout(function(){document.querySelectorAll('#main_image_0 input')[0].checked = true;},200);
		},
		validateUploadForm() {
			this.errors = [];
			if (!this.product.auction_id) {
				this.errors.push("err_select_auction");
			}

			if (
				!this.product.Category.main ||
				this.product.Category.main.length < 1
			) {
				this.errors.push("err_select_category");
			}

			if (!this.product.name) {
				this.errors.push("err_product_name_empty");
			} else if (this.product.name.length > 200) {
				this.errors.push("err_product_name_too_long");
			}

			this.product.sku = parseInt(this.product.sku);
			if (!this.product.sku) {
				this.errors.push("err_sku_empty");
			} else if (!Number.isInteger(this.product.sku)) {
				this.errors.push("err_sku_only_number");
			} else if (this.product.sku < 100000 || this.product.sku > 999999) {
				this.errors.push("err_sku_not_in_range");
			}

			this.product.Bid.price = parseInt(this.product.Bid.price);
			if (!this.product.Bid.price) {
				this.errors.push("err_price_empty");
			} else if (!Number.isInteger(this.product.Bid.price)) {
				this.errors.push("err_only_number");
			}

			if (!this.product.Images.length && !this.preview.length) {
				this.errors.push("err_no_image");
			}

			if (this.errors.length) return true;
			return false;
		},
		uploadProduct() {
			var _this = this;
			_this.loading = true;
			_this.selectedLangTab = 0;
			this.product.price = this.product.Bid.price
			const tags = _this.product.Category.tags;
			const tmpTags =  _this.product.Category.tags.map(t => t.id);
			_this.product.Category.tags = tmpTags;
			if (this.validateUploadForm()) {
				console.log(_this.errors);
				_this.loading = false;
				return false;
			}

			const formData = new FormData();
			for (var i in this.product.files) {
				formData.append("file_" + i, this.product.files[i]);
			}

			formData.append("product", JSON.stringify(this.product));
			//formData.append('name', this.product.name)
			//formData.append('description', this.product.description)
			//formData.append('product_type', this.product.product_type)

			_this.$http
				.post("/product-upload", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(response => {
					_this.loading = false;
					console.log("ProductUpload", response);
					// _this.product.Category.tags = tags;
					if(response.data.error){
						_this.loading = false;
						if(typeof response.data.type !== "undefined" && response.data.type == "SequelizeUniqueConstraintError" ){
							_this.$buefy.snackbar.open({
								message: _this.$t("SKU exists") ,
								type: "is-danger",
								duration: 5000,
								queue: false,
							});
						}else{
							_this.$buefy.snackbar.open({
								message: _this.$t(response.data.error),
								type: "is-danger",
								duration: 5000,
								queue: false,
							});
						}
					}else{
						if (_this.$route.params.product_id !== undefined) {
							_this.getProduct(_this.$route.params.product_id);
							_this.$buefy.snackbar.open({
								message: _this.$t("Saved"),
								queue: false,
							});
						} else {
							//_this.product.name = null;
							_this.product.description = null;
							_this.product.long_description = {
								en: { name: null, description: null }
							};
							_this.product.Category.tags = tags;

							// _this.product.Category.continent = null;
							// _this.product.Category.country = null;
							// _this.product.Category.county = null;
							//_this.product.Category.city = null;
							_this.product.files = [];
							_this.preview = [];
							_this.product.sku = 1 + parseInt(_this.product.sku);
							_this.product.main_image = null;
							_this.loading = false;
							_this.$buefy.snackbar.open({
								message: _this.$t("Upload successful"),
								queue: false,
							});
						}
					}
				})
				.catch((error, resp, data) => {
					_this.loading = false;
					_this.$buefy.snackbar.open({
						message: _this.$t("Upload failed"),
						type: "is-danger",
						duration: 5000,
						queue: false,
					});
				});

		},
		translate() {
			var _this = this;
			this.loading = true;
			this.$http
				.post("/translate", {
					name: this.product.name ? this.product.name : "",
					description: this.product.description ? this.product.description : ""
				})
				.then(function(response) {
					_this.product.long_description.en = response.data;
					_this.selectedLangTab = 1;
					_this.loading = false;
					console.log(response);
				})
				.catch(function(err) {
					_this.loading = false;
					console.log(err);
				});
		},
		normalizer(node) {
			return {
				id: node.id,
				label: node.name,
				children: node.children
			};
		},
		loadOptions({ action, parentNode, callback }) {
			// Typically, do the AJAX stuff here.
			// Once the server has responded,
			// assign children options to the parent node & call the callback.

			if (action === LOAD_CHILDREN_OPTIONS) {
				switch (parentNode.id) {
					case "success": {
						simulateAsyncOperation(() => {
							parentNode.children = [
								{
									id: "child",
									label: "Child option"
								}
							];
							callback();
						});
						break;
					}
					case "no-children": {
						simulateAsyncOperation(() => {
							parentNode.children = [];
							callback();
						});
						break;
					}
					case "failure": {
						simulateAsyncOperation(() => {
							callback(new Error("Failed to load options: network error."));
						});
						break;
					}
					default: /* empty */
				}
			}
		}
	},
	mounted() {

		// eslint-disable-next-line no-unused-vars
		var _this = this;
		this.getUser();
		this.getAuctions();
		this.getCategories();
		this.getContinents();
		this.getCountries();
		this.getCounties();
		this.getTags();
		if (this.$route.params.product_id !== undefined) {
			console.log("get product");
			this.getCities(this.$route.params.product_id);
			this.getProduct(this.$route.params.product_id);
		} else {
			this.citiloaded = true;
			this.getSKU();
		}
		this.product.auction_id = this.$route.query.auction_id;
		//this.getCities();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.no-image {
  width: 100%;
  height: 100%;
  min-height: 400px;
  background-color: white;
}

.preview img {
  max-height: 90px;
}
.preview {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
}

/* bootstrap 4 check fix */
.form-check {
  padding-left: 1.25rem;
}

.form-check-label {
  padding-left: 0;
}

label.error {
  color: red;
  font-size: 0.8em;
}

textarea {
  height: 8.5rem;
}

#frontupload_product_type {
  height: 21rem;
}

.autocomplete-sm {
  font-size: 0.875rem;
}

#message {
  overflow: auto;
  max-height: 65vh;
}

.front-upload.thumb.left {
  display: inline-block;
}

.front-upload.thumb.left img {
  width: 150px;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

@media all and (min-width: 1200px) {
  .container {
    max-width: 100%;
  }
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file >>> .custom-file-input:lang(hu) ~ .custom-file-label::after {
  content: "Keresés";
}
.title {
  text-align: right;
}
.modal >>> .modal-close {
  background-color: black !important;
}
.modal >>> .product-details-prev {
  padding: 10px;
  transform: scale(0.9) !important;
}
/*
.modal >>> .modal-background{
}
*/
.modal >>> .modal-content {
  background-color: white !important;
  /*width: 100vw !important;*/
}
.modal >>> .modal-content > .columns {
  width: 100%;
  height: 100%;
}
.has-numberinput >>> input {
  border-color: #dbdbdb;
}
.has-numberinput >>> .help {
  display: none;
}

.product-upload >>> .b-tabs .tab-content {
  padding: 0.5rem;
  padding-left: 0;
  padding-right: 0;
}

* >>> .upload.control {
  display: flex;
  > div {
    width: 100%;
  }
}

.section.upload {
  padding-top: 1rem;
}

.columns {
  margin-bottom: 0;
}

.b-tabs:not(:last-child) {
  margin-bottom: 0;
}

.field.is-grouped >>> .control {
  margin-bottom: 0;
}

</style>
